var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_13",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5L8.597 12.0875L9.24325 11.4453L11.5432 13.7453V5.15375H12.4662V13.7453L14.7662 11.4453L15.4125 12.0875L12 15.5ZM6.68975 18.8463C6.25908 18.8463 5.89541 18.6979 5.59875 18.4013C5.30208 18.1046 5.15375 17.7405 5.15375 17.309V14.9183H6.077V17.3078C6.077 17.4616 6.14108 17.6026 6.26925 17.7308C6.39741 17.8589 6.53841 17.923 6.69225 17.923H17.3077C17.4616 17.923 17.6026 17.8589 17.7307 17.7308C17.8589 17.6026 17.923 17.4616 17.923 17.3078V14.9183H18.8462V17.309C18.8462 17.7405 18.6979 18.1046 18.4012 18.4013C18.1046 18.6979 17.7409 18.8463 17.3102 18.8463H6.68975Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.38be407a51c559576e5d4f5dda8dd93a.svg";
export { ForwardRef as ReactComponent };